export default function CircularExclamatory({
    style,
}) {
    return <svg style={style} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9" fill="#F8FAFB" stroke="#EE5252" strokeWidth="1.5" />
        <path d="M10 5.10156V10.5016" stroke="#EE5252" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.25 13.75C11.25 14.4404 10.6904 15 10 15C9.30964 15 8.75 14.4404 8.75 13.75C8.75 13.0596 9.30964 12.5 10 12.5C10.6904 12.5 11.25 13.0596 11.25 13.75Z" fill="#EE5252" />
    </svg>
}